// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bWzG","footer":"styles_footer__1q222"};